import { memo, useEffect } from 'react';
import { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import axios from 'axios';
import { Buffer } from 'buffer';
import Spinner from "./Spinner";
import server_config from '../ServerConfiguration';
import { useSelector } from 'react-redux';
import { selectEditMode } from '../slices/editMode/editModeSlice';

const node_server_address = server_config["node_server_address"];

const hashCode = (str) => {
    let hash = 0;
    if (!str || str.length === 0) {
        return hash;
    }
    for (let i = 0; i < str.length; i++) {
        let chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

const handleDownload = (pdfData) => {
    const linkSource = `data:application/pdf;base64,${pdfData}`;
    const downloadLink = document.createElement("a");
    const fileName = "Sample.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};


//THIS IS TEMPORARY

const ViewPdfLauncher = ({ label, pdfData }) => {
    return (
        <Modal
            style={{ position: "absolute !important", top: "0px", left: "0px", width: "100%", height: "100%", padding: "0px !important", margin: "0px !important" }}
            className="fullscreenModal"
            trigger={<span style={{ color: "#4183C4", cursor: "pointer" }}>{label}</span>}
            centered={false}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            closeOnDimmerClick={true}
            content={pdfData ? <embed src={`data:application/pdf;base64,${pdfData}`} type="application/pdf" width="100%" height="99.6%" /> : <><Spinner /></>}
            actions={[{ key: 'done', content: 'Close', negative: true }]}
        />
    )
}

const getThePDF = async (fhirJson, setPdfState, setJsonHashState) => {
    if (fhirJson) {
        setJsonHashState(async prevState => {
            let hash = hashCode(fhirJson.toString());
            if (hash !== prevState) {  //So it doesn't do a repeat submission
                setJsonHashState(hash);
                console.log("CALLING SERVER with fhircompositionjsontopdf");
                await axios({
                    method: 'POST',
                    //url: server_address + ':' + ports["master_server"] + '/',
                    url: node_server_address,
                    timeout: 120000,
                    data: { "functionid": "fhircompositionjsontopdf", "fhirJson": fhirJson, "libraryfunction": "axios" },
                }).then(async (resp) => {
                    if (resp?.data?.success && resp.data.pdf?.data) {
                        setPdfState(Buffer.from(resp.data.pdf.data).toString("base64"));
                        //return new Promise(resolve =>
                        //    resolve({ data: response.storedMediaLibrary })
                        //)
                    }
                    return resp.data;
                }).catch(async (error) => { console.log(error); });

            }
            return hash;
        });
    }
}

const CompositionPdfViewer = memo(({ fhirJson }) => {
    const [pdfState, setPdfState] = useState();
    const [, setJsonHashState] = useState();
    const editMode = useSelector(state => selectEditMode(state));

    useEffect(() => {
        if (!editMode) {
            getThePDF(fhirJson, setPdfState, setJsonHashState);
        }
    }, [editMode, fhirJson]); //removed fhirJson dependency to avoid calling the function with each editing change; consider putting it back but only if !editMode

    return <div className="unselectable">
        <ViewPdfLauncher label="View PDF" pdfData={pdfState} />
        <button type="button" style={{ marginLeft: "12px" }}
            onClick={() => { handleDownload(pdfState); }}
            disabled={!pdfState}>{!pdfState ? "Loading..." : "Download PDF"}</button>
        <br />
    </div>;
});

export default CompositionPdfViewer;
export { ViewPdfLauncher };